document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ptc-facets').forEach((facets) => {
    const toggles = [...facets.querySelectorAll('[data-facets-toggle]')];
    const closeButton = facets.querySelector('[data-facets-close]');
    const panel = facets.querySelector('[data-facets-panel]');
    const sortSelect = facets.querySelector('[data-sort-select]');
    const closeFacets = () => {
      facets.classList.remove('is-open');
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    };
    const sortByDiscount = () => {
      const grid = document.querySelector('#ProductGrid');
      if (!grid) return;
      [...grid.querySelectorAll('[data-product-card]')]
        .sort((left, right) => Number(right.dataset.discount || 0) - Number(left.dataset.discount || 0))
        .forEach((card) => grid.appendChild(card));
    };

    toggles.forEach((toggle) => toggle.addEventListener('click', () => {
      const target = toggle.dataset.facetTarget || 'all';
      const wasOpen = facets.classList.contains('is-open') && toggle.getAttribute('aria-expanded') === 'true';
      const open = !wasOpen;

      facets.classList.toggle('is-open', open);
      toggles.forEach((control) => control.setAttribute('aria-expanded', String(open && control === toggle)));

      if (!open) return;
      const facetGroups = [...facets.querySelectorAll('[data-facet-index]')];
      if (target === 'all') {
        facetGroups.forEach((group) => { group.open = group.querySelector('input:checked') !== null; });
        panel?.scrollTo({ top: 0 });
        return;
      }

      facetGroups.forEach((group) => { group.open = group.dataset.facetIndex === target; });
      const activeGroup = facets.querySelector(`[data-facet-index="${target}"]`);
      if (activeGroup && panel) panel.scrollTop = Math.max(0, activeGroup.offsetTop - 12);
    }));
    closeButton?.addEventListener('click', closeFacets);

    facets.querySelectorAll('[data-facets-submit]').forEach((input) => input.addEventListener('change', () => {
      if (input === sortSelect && input.value === 'discount-descending') {
        sortByDiscount();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', input.value);
        window.history.replaceState({}, '', url);
        closeFacets();
        return;
      }
      facets.requestSubmit();
    }));

    document.addEventListener('pointerdown', (event) => {
      if (!facets.contains(event.target)) closeFacets();
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && facets.classList.contains('is-open')) {
        closeFacets();
        toggles[0]?.focus();
      }
    });

    const requestedSort = new URL(window.location.href).searchParams.get('sort_by');
    if (requestedSort === 'discount-descending' && sortSelect) {
      sortSelect.value = requestedSort;
      sortByDiscount();
    }
  });

  const couponModal = document.querySelector('[data-promo-coupon-modal]');
  if (!couponModal) return;

  const root = couponModal.dataset.rootUrl || window.Shopify?.routes?.root || '/';
  const emptyState = couponModal.querySelector('[data-promo-modal-empty]');
  const readyState = couponModal.querySelector('[data-promo-modal-ready]');
  const codeOutput = couponModal.querySelector('[data-promo-modal-code]');
  const status = couponModal.querySelector('[data-promo-modal-status]');
  const openCart = couponModal.querySelector('[data-promo-open-cart]');
  let couponCode = '';

  const cartEndpoint = (path) => `${root.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
  const showModalState = (hasItems) => {
    emptyState.hidden = hasItems;
    readyState.hidden = !hasItems;
    status.textContent = '';
    status.classList.remove('is-error');
    if (codeOutput) codeOutput.textContent = couponCode;
    if (!couponModal.open) couponModal.showModal();
  };

  const applyCoupon = async () => {
    couponModal.classList.add('is-loading');
    status.textContent = 'Aplicando cupón…';
    status.classList.remove('is-error');
    try {
      const response = await fetch(cartEndpoint('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: couponCode, attributes: { _ptc_coupon_code: couponCode } })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No fue posible aplicar el cupón.');
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart, couponCode, source: 'collection-promo' }
      }));
      status.textContent = 'Cupón guardado en tu carrito.';
      return cart;
    } catch (error) {
      status.textContent = error.message;
      status.classList.add('is-error');
      throw error;
    } finally {
      couponModal.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-promo-coupon]');
    if (!trigger) return;
    event.preventDefault();
    couponCode = trigger.dataset.couponCode?.trim() || '';
    if (!couponCode) return;
    try {
      const response = await fetch(cartEndpoint('cart.js'), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No fue posible consultar tu carrito.');
      const cart = await response.json();
      showModalState(cart.item_count > 0);
    } catch (error) {
      window.alert(error.message);
    }
  });

  couponModal.querySelectorAll('[data-promo-modal-close]').forEach((button) => {
    button.addEventListener('click', () => couponModal.close());
  });
  couponModal.addEventListener('click', (event) => {
    if (event.target === couponModal) couponModal.close();
  });
  openCart?.addEventListener('click', async () => {
    try {
      await applyCoupon();
      couponModal.close();
      document.querySelector('[data-cart-link]')?.click();
    } catch (_) {}
  });
});
